function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure " + obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
import { useTranslation } from "react-i18next";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { useColumnVisibilityContext } from "../../contexts/ColumnVisibilityContext";
import { useCurrentGroupContext } from "../../contexts/CurrentGroupContext";
var tKey = "features.Chat.Messages.OptionsMenu";
function OptionsMenu(props) {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useColumnVisibilityC = useColumnVisibilityContext(),
    showLeftColumn = _useColumnVisibilityC.showLeftColumn,
    showRightColumn = _useColumnVisibilityC.showRightColumn;
  var _useCurrentGroupConte = useCurrentGroupContext(),
    currentGroup = _useCurrentGroupConte.currentGroup,
    setCurrentGroup = _useCurrentGroupConte.setCurrentGroup;
  var forwardProps = function (_ref) {
    var rest = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
    return rest;
  }(props);
  function handleClickCloseChat(event) {
    event.preventDefault();
    showLeftColumn();
    setCurrentGroup(undefined);
  }
  return /*#__PURE__*/React.createElement(Menu, _extends({
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "right"
    },
    keepMounted: true,
    transformOrigin: {
      vertical: "top",
      horizontal: "right"
    }
  }, forwardProps), /*#__PURE__*/React.createElement(MenuItem, {
    onClick: showRightColumn
  }, currentGroup.multi ? t("".concat(tKey, ".groupInfo")) : t("".concat(tKey, ".contactInfo"))), /*#__PURE__*/React.createElement(MenuItem, {
    onClick: handleClickCloseChat
  }, t("".concat(tKey, ".closeChat"))));
}
export default OptionsMenu;